import { Fab as MuiFab } from '@mui/material';
import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

const Fab = styled(MuiFab)(({ theme }) => ({
  '&:hover': {
    background: '#121212',
  },
  '@keyframes sidebarAnimation': {
    '0%': {
      boxShadow: `${theme.palette.primary.contrastText} 0px 0px 0px 0px`,
    },
    '25%': {
      boxShadow: `${theme.palette.primary.contrastText} 0px 0px 0px 10px`,
    },
    '100%': {
      boxShadow: `${theme.palette.primary.contrastText} 0px 0px 0px 0px`,
    },
  },
  animation: '2s ease infinite sidebarAnimation',
  background: '#121212',
  height: 80,
  width: 80,
}));

type PropsTypes = {
  icon: ReactNode;
};

export default function CustomizeFab(props: PropsTypes) {
  const { icon } = props;

  return <Fab size="large">{icon}</Fab>;
}
